import EmployeePayrollPerformance from "../../../../components/company/expense/employee-payroll/employee-payroll-performance";

export default function EmployeePayrollPerformancePage(){
    return <EmployeePayrollPerformance/>
}